import React, { useState } from 'react';
import { Tooltip, Button, Pagination } from 'antd';
import { Edit } from '@material-ui/icons';
import { FormattedMessage, useIntl } from 'react-intl';
import EstablishmentsFormModal from 'components/Dashboard/WorldCup/Establishments/EstablishmentsFormModal';
import { Establishments } from 'core/worldCup/establishments/types';
import { PAGE_SIZE_OPTIONS } from 'utilities/constants';

type EstablishmentsTableType = {
  establishmentsData: Array<Establishments | null>;
  total: number;
  current: number;
  pageSize: number;
  onChangePage: (page: number, size: number) => void;
  setCurrent: (e: number) => void;
  setPageSize: (e: number) => void;
};

const EstablishmentsTable: React.FC<EstablishmentsTableType> = ({
  establishmentsData,
  total,
  current,
  pageSize,
  onChangePage,
  setCurrent,
  setPageSize,
}) => {
  const [isShowDetailModal, setShowDetailModal] = useState(false);
  const [establishmentInfo, setEstablishmentInfo] = useState<Establishments | null>(null);
  const intl = useIntl();

  const handleChangePage = (page: number, size: number) => {
    setCurrent(page);
    setPageSize(size);
    onChangePage(page, size);
  };

  const handleShowSizeChange = (_c: number, s: number) => {
    handleChangePage(1, s);
  };

  return (
    <div className="establishments_table_layout" id="establishments_table_layout">
      <div className="table_header">
        <div className="id">
          <FormattedMessage id="ID" />
        </div>
        <div className="establishment_main">
          <FormattedMessage id="Establishment" />
        </div>
        <div className="status">
          <FormattedMessage id="Status" />
        </div>
        <div className="actions">
          <FormattedMessage id="Actions" />
        </div>
      </div>
      <div>
        <div className="table_content" id="establishments_table_content">
          {Array.isArray(establishmentsData) &&
            establishmentsData.map((item, index) => (
              <div className={`table_item type_state_${item?.isActive}`} key={index} id={`establishment_item_${item?.id}`}>
                <div className="id">
                  <p>{item?.id}</p>
                </div>
                <div className="establishment_main">
                  <p className="main_name">{item?.name}</p>
                  {item?.sponsor?.name && (
                    <p className="sub_info">{item.sponsor.name}</p>
                  )}
                  {item?.address && (
                    <p className="sub_info">{item.address}</p>
                  )}
                </div>
                <div className="status">
                  <span className={`status_badge ${item?.isActive ? 'active' : 'inactive'}`}>
                    {item?.isActive ? intl.formatMessage({ id: 'Active' }) : intl.formatMessage({ id: 'Inactive' })}
                  </span>
                </div>
                <div className="actions">
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: 'Edit establishment' })}
                    id="establishment_edit_tooltip"
                  >
                    <Button
                      className="edit_btn"
                      onClick={() => {
                        setEstablishmentInfo(item);
                        setShowDetailModal(true);
                      }}
                      id="establishment_edit_btn"
                    >
                      <Edit />
                    </Button>
                  </Tooltip>
                </div>
              </div>
            ))}
        </div>
        <div className="pagination_wrapper">
          <Pagination
            showSizeChanger
            defaultCurrent={1}
            defaultPageSize={10}
            current={current}
            pageSize={pageSize}
            pageSizeOptions={PAGE_SIZE_OPTIONS}
            total={total}
            onChange={handleChangePage}
            onShowSizeChange={handleShowSizeChange}
          />
          <div className="total">Resultados: {total}</div>
        </div>
      </div>
      <EstablishmentsFormModal
        mode="modal"
        isOpenModal={isShowDetailModal}
        onCloseModal={() => setShowDetailModal(false)}
        onSaveSuccess={() => onChangePage(current, pageSize)}
        establishment={establishmentInfo}
      />
    </div>
  );
};

export default EstablishmentsTable;
